type SvgProps = {
    className: string,
};

const ArrowUp = (props: SvgProps): JSX.Element => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.975 21a1 1 0 01-1-1V5a1 1 0 112 0v15a1 1 0 01-1 1z"
            stroke="none"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.706 11.758a1 1 0 01-1.415-.003l-5.316-5.338-5.315 5.338a1 1 0 01-1.418-1.41l6.024-6.05a1 1 0 011.418 0l6.025 6.05a1 1 0 01-.003 1.413z"
            stroke="none"
        />
    </svg>
);

export default ArrowUp;
